import React from 'react';
import { PageLayout } from '../components/PageLayout';
import { PhoneDisplay } from '../components/PhoneDisplay';
import { NumPad } from '../components/NumPad';
import { PrimaryButton } from '../components/PrimaryButton';
import { useLanguage } from '../i18n/LanguageContext';
import styles from './PhoneInputPage.module.css';

interface PhoneInputPageProps {
  phone: string;
  onDigit: (digit: string) => void;
  onDelete: () => void;
  onClear: () => void;
  onNext: () => void;
  onBack?: () => void;
  takeoutEnabled?: boolean;
  waitingCount?: number;
  estimatedMinutes?: number;
  takeoutWaitingCount?: number;
  takeoutEstimatedMinutes?: number;
  storeImage?: string | null;
}

/**
 * 전화번호 입력 페이지
 * - 제목, 전화번호 표시, 숫자 키패드, 다음 버튼
 */
export function PhoneInputPage({
  phone,
  onDigit,
  onDelete,
  onClear,
  onNext,
  onBack,
  takeoutEnabled = false,
  waitingCount = 0,
  estimatedMinutes = 0,
  takeoutWaitingCount = 0,
  takeoutEstimatedMinutes = 0,
  storeImage = null,
}: PhoneInputPageProps) {
  const { t } = useLanguage();
  const isValid = phone.length >= 10;

  return (
    <PageLayout
      title={t('phone_title')}
      takeoutEnabled={takeoutEnabled}
      waitingCount={waitingCount}
      estimatedMinutes={estimatedMinutes}
      takeoutWaitingCount={takeoutWaitingCount}
      takeoutEstimatedMinutes={takeoutEstimatedMinutes}
      storeImage={storeImage}
      footer={
        <div className={styles.buttonWrapper}>
          <div className={styles.buttonRow}>
            {onBack && (
              <button type="button" className={styles.backBtn} onClick={onBack}>
                &lt; {t('phone_prev')}
              </button>
            )}
            <div className={styles.nextWrapper}>
              <PrimaryButton onClick={onNext} disabled={!isValid}>
                {t('phone_next')} &gt;
              </PrimaryButton>
            </div>
          </div>
        </div>
      }
    >
      <div className={styles.content}>
        <PhoneDisplay phone={phone} />
        <NumPad onDigit={onDigit} onDelete={onDelete} onClear={onClear} />
      </div>
    </PageLayout>
  );
}
